var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2407 13.2467H14.8674C13.2865 13.2467 11.9999 11.9609 11.999 10.3809C11.999 8.79922 13.2857 7.51255 14.8674 7.51172H18.2407C18.5857 7.51172 18.8657 7.79172 18.8657 8.13672C18.8657 8.48172 18.5857 8.76172 18.2407 8.76172H14.8674C13.9749 8.76255 13.249 9.48839 13.249 10.3801C13.249 11.2709 13.9757 11.9967 14.8674 11.9967H18.2407C18.5857 11.9967 18.8657 12.2767 18.8657 12.6217C18.8657 12.9667 18.5857 13.2467 18.2407 13.2467Z",
    fill: "url(#paint0_linear_1798_40773)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2488 10.9531H14.9888C14.6438 10.9531 14.3638 10.6731 14.3638 10.3281C14.3638 9.98313 14.6438 9.70312 14.9888 9.70312H15.2488C15.5938 9.70312 15.8738 9.98313 15.8738 10.3281C15.8738 10.6731 15.5938 10.9531 15.2488 10.9531Z",
    fill: "url(#paint1_linear_1798_40773)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1798_40773",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 2.5H18.8653V18.4774H1.6665V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1798_40773)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66484 3.75C4.59817 3.75 2.9165 5.43167 2.9165 7.49833V13.4792C2.9165 15.5458 4.59817 17.2275 6.66484 17.2275H13.8682C15.9348 17.2275 17.6157 15.5458 17.6157 13.4792V7.49833C17.6157 5.43167 15.9348 3.75 13.8682 3.75H6.66484ZM13.8682 18.4775H6.66484C3.909 18.4775 1.6665 16.235 1.6665 13.4792V7.49833C1.6665 4.74167 3.909 2.5 6.66484 2.5H13.8682C16.624 2.5 18.8657 4.74167 18.8657 7.49833V13.4792C18.8657 16.235 16.624 18.4775 13.8682 18.4775Z",
    fill: "url(#paint2_linear_1798_40773)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5705 7.53125H6.07129C5.72629 7.53125 5.44629 7.25125 5.44629 6.90625C5.44629 6.56125 5.72629 6.28125 6.07129 6.28125H10.5705C10.9155 6.28125 11.1955 6.56125 11.1955 6.90625C11.1955 7.25125 10.9155 7.53125 10.5705 7.53125Z",
    fill: "url(#paint3_linear_1798_40773)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40773",
    x1: 15.4324,
    y1: 7.51172,
    x2: 15.4324,
    y2: 13.2467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82DD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46770E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40773",
    x1: 15.1188,
    y1: 9.70312,
    x2: 15.1188,
    y2: 10.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82DD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46770E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40773",
    x1: 10.2661,
    y1: 2.5,
    x2: 10.2661,
    y2: 18.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82DD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46770E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40773",
    x1: 8.32087,
    y1: 6.28125,
    x2: 8.32087,
    y2: 7.53125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82DD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46770E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsIcon);
export default __webpack_public_path__ + "static/media/deals-icon.dce1451e7db113bb66defdeafb882a18.svg";
export { ForwardRef as ReactComponent };